module.exports = __webpack_public_path__ + "45b9b00274ab3b2be6515e198ecbbd87.svg";